import { clearToken } from '../reducers/auth.reducer';
import callApi from '../../utils/api/callAPI';
import { createAsyncThunk } from '@reduxjs/toolkit';

/** Gọi API đăng nhập
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.email Email đăng nhập
 * @param {string} values.password Mật khẩu
 */
export const login = createAsyncThunk(
  'post/users/v3/customer/login',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/customer/login',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        const data = response.result?.data;
        return {
          user: data,
          accessToken: data.token,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/** Gọi API đăng ký tài khoản
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.fullname Họ và tên
 * @param {string} values.email Email đăng ký
 * @param {string} values.phone Số điện thoại
 * @param {string} values.password Mật khẩu
 */
export const register = createAsyncThunk(
  'post/users/v3/customer/signup',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/customer/signup',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        const data = response.result.data;
        return { data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/** Gọi API quên mật khẩu
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.email Email người dùng
 * @param {string} values.redirect_url URL chuyển hướng sau khi nhận liên kết đặt lại mật khẩu
 */
export const forgotPassword = createAsyncThunk(
  'post/users/v3/forgot-password',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/forgot-password',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        const data = response.result?.data;
        return {
          data: data,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/** Gọi API đặt lại mật khẩu
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.id ID người dùng
 * @param {string} values.token Mã đặt lại mật khẩu
 * @param {string} values.new_password Mật khẩu mới
 */
export const resetPassword = createAsyncThunk(
  'post/users/v3/reset-password',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/reset-password',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/** Gọi API đổi mật khẩu
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.old_password Mật khẩu hiện tại
 * @param {string} values.new_password Mật khẩu mới
 */
export const changePassword = createAsyncThunk(
  'post/users/v3/change-password',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/change-password',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/**
 * Gọi API đăng nhập bằng OAuth
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.oauthCode Mã OAuth trả về từ nhà cung cấp
 * @param {string} values.provider Nhà cung cấp OAuth (mặc định là "google")
 */
export const oauthLogin = createAsyncThunk(
  'post/users/v3/customer/oauth_login',
  async ({ oauthCode, provider = 'google' }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/customer/oauth_login',
        method: 'post',
        data: {
          oauth_code: oauthCode,
          provider,
        },
      });

      const response = res.data;
      if (response.success) {
        const data = response.result?.data;
        return {
          user: data,
          accessToken: data.token,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/**
 * Gọi API kích hoạt tài khoản
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.token Mã kích hoạt
 */
export const activateAccount = createAsyncThunk(
  'post/users/v3/customer/activate',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/customer/activate',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/**
 * Gọi API kích hoạt tài khoản
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.token Mã kích hoạt
 * @param {string} values.new_email Email mới
 */
export const confirmedChangeEmail = createAsyncThunk(
  'post/users/v3/customer/change_email',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/customer/change_email',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/**
 * Gọi API kích hoạt tài khoản
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.token Mã kích hoạt
 */
export const deleteAccount = createAsyncThunk(
  'post/users/v3/customer/delete',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/customer/delete',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/**
 * Gọi API cập nhật thông tin cá nhân
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.fullname Họ và tên
 * @param {string} values.gender Giới tính
 * @param {string} values.birthday Ngày sinh
 * @param {string} values.phone Số điện thoại
 * @param {File} values.avatar Ảnh đại diện
 */
export const updateProfile = createAsyncThunk(
  'put/users/v3/customer/update_profile',
  async (values, { dispatch }) => {
    const { fullname, gender, birthday, phone, avatar } = values;

    const formData = new FormData();
    if (fullname) formData.append('fullname', fullname);
    if (gender) formData.append('gender', gender);
    if (birthday) formData.append('birthday', birthday);
    if (phone) formData.append('phone', phone);
    if (avatar) formData.append('avatar', avatar);
    try {
      const res = await callApi({
        endpoint: 'users/v3/customer/update_profile',
        method: 'put',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/**
 * Gọi API đổi email
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.email Email mới
 * @param {string} values.redirect_url URL chuyển hướng sau khi đổi email
 */
export const changeEmail = createAsyncThunk(
  'push/users/v3/customer/change_email',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/customer/change_email',
        method: 'put',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/**
 * Gọi API đổi email
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.new_email Email mới
 * @param {string} values.redirect_url URL chuyển hướng sau khi đổi email
 */
export const requestChangeEmail = createAsyncThunk(
  'put/users/v3/customer/send_confirm_change_email',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/customer/send_confirm_change_email',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/**
 * Gọi API xóa tài khoản
 * @param {Object} values Dữ liệu gửi lên API
 * @param {string} values.redirect_url URL chuyển hướng sau khi xóa tài khoản
 */
export const requestDeleteAccount = createAsyncThunk(
  'put/users/v3/customer/send_confirm_delete',
  async (values, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'users/v3/customer/send_confirm_delete',
        method: 'post',
        data: values,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/** Làm mới thông tin người dùng (gồm permissions) khi khởi động app, để quyền do admin đổi được cập nhật mà không cần đăng nhập lại
 * @param {string} userId ID người dùng đang đăng nhập
 */
export const refreshUser = createAsyncThunk(
  'get/users/v3/customer/detail',
  async (userId, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: `users/v3/customer/detail/${userId}`,
        method: 'get',
      });

      const response = res.data;
      if (response.success) {
        return { user: response.result?.data };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      throw error;
    }
  }
);

/** Gọi API đăng xuất
 */
export const logout = () => {
  return async dispatch => {
    try {
      dispatch(clearToken());
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
    }
  };
};
